<template lang="pug">
.col.col-12.col-md-grow.col-lg-grow.q-mt-lg(v-if="!part.main")
  q-expansion-item(flat group="part" default-opened expand-icon-class="hidden")
    template(v-slot:header)
      q-item-section(avatar)
        q-icon(name="fas fa-cogs")
      q-item-section
        .hover-container
          in-place.inplace-part-name(op="replace" :value="titleVal" :edit='edit' @save="nameChanged"
                  :submit-options="{path: `/parts/${partIndex}/name/0/value`}")
            template(v-slot:view="{value}")
              .text-h7 {{ value | capitalize }}
            template(v-slot:edit="{value, input}")
              q-input(:value="value" @input="input" required autofocus ref="name"
                :rules="[$rules.required('Název části předmětu je povinný'), $rules.minLength(3, 'Název musí být delší')]")
              q-btn(@click="edit=false" outline v-if="edit" icon="cancel" color="grey-5") Storno
              q-btn.q-ml-md(color="secondary" outline @click="saveChanges" v-if="edit" icon="done") Uložit změny
        .text-caption.text-weight-light {{ $langTitle(part.materialType) | capitalize }}
      q-item-section(side)
        q-btn.hover-container-icon.full-height.float-right(icon="delete"
          flat size="md" color="negative" @click="confirmRemoval = true")
          q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
            .text-caption Odebrat část
    q-card
      q-card-section
        //- q-btn.hover-container-icon.full-height.float-right(icon="edit"
        //-   flat size="md" color="primary" @click="edit = true")
        //-   q-tooltip(content-class="bg-accent" anchor="top middle" self="bottom middle")
        //-     .text-caption Upravit část
        q-separator
        q-markup-table.q-pa-sm(flat separator="none")
          tbody
            kv(@change="matTypeChange"
              :container="container" label="Materiál" :item="part" path="materialType" ref="material"
              :rules="[$rules.required('Materiál části předmětu je povinný')]"
              :editor-options="{taxonomy: 'material-type'}" type="taxonomy" :edit="edit")
            kv(:container="container" label="Technologie výroby"
              v-if="relevantTaxonomies.includes('fabrication-technology')"
              :editor-options="{taxonomy: 'fabrication-technology', scope: selectedMatType}"
              :item="part" path="fabricationTechnology" type="taxonomy-array" :edit="edit")
            kv(:container="container" label="Barva" :item="part || []" path="color"
              v-if="relevantTaxonomies.includes('color')"
              :editor-options="{taxonomy: 'color', scope: selectedMatType}" type="taxonomy-array" :edit="edit")
  q-dialog(v-model="confirmRemoval" persistent)
    q-card
      q-card-section.row.items-center
        span.q-ml-sm Opravdu chcete smazat část&nbsp;
        span.text-weight-bolder  {{ $langTitle(title) }}
      q-card-actions(align="right")
        q-btn(flat label="Ne" color="primary" v-close-popup)
        q-btn(flat label="Ano" color="negative" v-close-popup @click="removePart")
</template>
<style lang="stylus">
</style>
<script>
import { Component } from 'vue-property-decorator'
import KVPair from '../../KVPair.vue'
import InPlace from 'components/edit/InPlace.vue'
import { ValidationMixin } from '../../edit/validation'

export default @Component({
  props: {
    part: Object,
    partIndex: Number,
    oarepo: Object
  },
  components: {
    'kv': KVPair,
    'in-place': InPlace
  }
})
class ObjectPartCard extends ValidationMixin {
  confirmRemoval = false
  selectedMatType = (this.part.materialType || { 'path': '/ostatni' }).path.split('/')[1]
  title = { 'title': this.part.name }
  titleVal = this.part.name[0]['value']
  container = `/parts/${this.partIndex || 0}`
  edit = false

  matTypeChange (val) {
    this.selectedMatType = val.path.split('/')[1]
  }

  get relevantTaxonomies () {
    return this.$taxonomies.relevantTaxonomies[this.selectedMatType] ||
      this.$taxonomies.relevantTaxonomies['ostatni']
  }

  async saveChanges () {
    const status = await this.validateRefs()
    if (!status) {
      this.notify$({ message: 'Opravte prosím chyby a zkuste znovu' })
      return
    }
    this.oarepo.patch().then(status => {
      this.edit = false
    })
  }

  nameChanged (e) {
    this.title = { 'title': e.parts[this.partIndex].name }
  }

  removePart () {
    this.$restorationObject.removeObjectPart(this.partIndex)
  }
}
</script>
<style lang="stylus">
.inplace-part-name .inplace-edit-btn
  display none !important
  visibility hidden !important
</style>
